var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dynamic-tag', {
    ref: "container",
    attrs: {
      "tag": _vm.activatorWrapper || 'div'
    }
  }, [_vm._t("activator", null, {
    activate: _vm.onActivate
  }), _vm._v(" "), _c('polaris-popover-overlay', {
    attrs: {
      "id": _vm.realId + 'Overlay',
      "active": _vm.active,
      "activator-id": _vm.activatorId,
      "preferred-position": _vm.preferredPosition
    },
    on: {
      "close": _vm.onClose
    },
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function(props) {
        return [_c('div', {
          ref: "content",
          class: _vm.classes
        }, [(!props.data.measuring) ? _c('div', {
          staticClass: "Polaris-Popover__Tip",
          style: ({
            left: props.data.tipPosition + 'px'
          })
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "Polaris-Popover__FocusTracker",
          attrs: {
            "tabindex": "0"
          },
          on: {
            "focus": _vm.handleFocusFirstItem
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "Polaris-Popover__Wrapper"
        }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
          staticClass: "Polaris-Popover__FocusTracker",
          attrs: {
            "tabindex": "0"
          },
          on: {
            "focus": _vm.handleFocusLastItem
          }
        })])]
      }
    }])
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17a09496", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a09496","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisPopover.vue
// module id = 205
// module chunks = 0